import { render, staticRenderFns } from "./tabPanel.vue?vue&type=template&id=2343d198&scoped=true&"
import script from "./tabPanel.vue?vue&type=script&lang=js&"
export * from "./tabPanel.vue?vue&type=script&lang=js&"
import style0 from "./tabPanel.vue?vue&type=style&index=0&id=2343d198&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2343d198",
  null
  
)

export default component.exports